import axios from "axios";

export const apiUrl = `https://api.sysprojud.com`;
// export const apiUrl = `http://localhost:1234`;

export const comunicaapiUrl = `https://comunicaapi.pje.jus.br/api/v1`;

// export const whatsappWebUrl = `http://localhost:3366`;
export const whatsappWebUrl = `https://whatsapp.sysprojud.com`;

export const api = axios.create({
    baseURL: apiUrl,
});

export const comunicaapi = axios.create({
    baseURL: comunicaapiUrl,
    headers: {
        'Content-Type': 'application/json',
    },
});

export const whatsappWEbApi = axios.create({
    baseURL: whatsappWebUrl,
    headers: {
        'Content-Type': 'application/json',
    },
});

api.interceptors.request.use(config => {
    const infoLogin = JSON.parse(String(sessionStorage.getItem("infoLogin")));
    config.headers.token = (infoLogin && infoLogin.token) ? infoLogin.token : '';
    return config;
});